import { render, staticRenderFns } from "./StitchColorRun.vue?vue&type=template&id=08d51a37&scoped=true&"
import script from "./StitchColorRun.vue?vue&type=script&lang=js&"
export * from "./StitchColorRun.vue?vue&type=script&lang=js&"
import style0 from "./StitchColorRun.vue?vue&type=style&index=0&id=08d51a37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d51a37",
  null
  
)

export default component.exports